export function getAuthoritativeDashboardPoInHandsDate(purchaseOrder = {}) {
  return purchaseOrder?.resolvedInhandsDate || purchaseOrder?.inHandsDate || null;
}
